// ═══ 차량별 필요 서류 동적 계산 — 공통 헬퍼 ═══
// 사용처: CarListTable.js (카드/테이블 뷰), CarListModals.js (서류 관리 모달)
// 3곳 동일 룰 보장 → 뷰 간 % 불일치 방지.
//
// 분기 기준:
//  1) 매입유형 (purchaseType) — CarEditModal.js:87-95 4가지 값 참조
//     - individual           : 일반개인 (nonbiz/tax_invoice 둘 다 불필요)
//     - individual_biz       : 개인사업자→비사업용 (nonbiz 필요)
//     - individual_biz_tax   : 개인사업자→사업용(세금계산서) (tax_invoice 필요)
//     - business             : 업체매입 (tax_invoice 필요)
//  2) 진행단계 (status) — 말소 단계 도달 시점에 해당 서류 요구
//  3) 대체 관계 — 말소증(malsoCert) 있으면 구매확인서(purchase_confirm) 불필요
//  4) 부타무역 전용 — companyId===1 만 품의서(pumui)
//  5) salesContract — 사용자 결정으로 필수 목록에서 제외
//  6) myunjang (수출면장) — 2026-05-12 Kyle 결정: status 무관 항상 필수.
//     이전 동작 (면장신청+ 단계에만 분모 포함) 폐기.
//     사유: 사용자 직관 = 수출 완료 기준 100%. 신규 차량 등록 직후 분모에 포함되어
//     수출면장 미저장 시 절대 100% 안 됨 (오인 방지).

var MALSO_REQUESTED = ['말소신청','말소완료','면장신청','면장완료','선적대기','선적완료'];
var MALSO_DONE = ['말소완료','면장신청','면장완료','선적대기','선적완료'];

function getRequiredDocs(car, hasDocFn) {
  car = car || {};
  var pt = car.purchaseType || 'individual';
  var status = car.status || '등록완료';
  var companyId = car.companyId || 0;
  var req = ['contract', 'registration'];

  // Level 2 — 매입유형별
  if (pt === 'business' || pt === 'individual_biz_tax') req.push('tax_invoice');
  if (pt === 'individual_biz') req.push('nonbiz');
  if (companyId === 1) req.push('pumui');

  // Level 3 — 말소 단계 (status 동적)
  if (MALSO_REQUESTED.indexOf(status) >= 0) req.push('malso');
  if (MALSO_REQUESTED.indexOf(status) >= 0) req.push('malsoCert');
  // 말소증 없으면 구매확인서로 대체
  var hasMalsoCert = typeof hasDocFn === 'function' && hasDocFn(car, 'malsoCert');
  if (!hasMalsoCert) req.push('purchase_confirm');
  // Level 4 — 수출면장 항상 필수 (2026-05-12 옵션 A)
  req.push('myunjang');

  // salesContract 는 필수 목록에서 제외 (사용자 결정 2026-04-21)

  return req;
}

module.exports = { getRequiredDocs: getRequiredDocs };
